module.exports = __webpack_public_path__ + "static/media/animated-logo-once.e85c15b2.svg";